<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadCallbackData(1, null, true)">

      <template slot="actions">
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download" @click="exportData">{{ $t('export') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="callbackSearchParams.from" :model="callbackSearchParams.from" :placeholder="$t('date_filter_from')" class="mb-3"></date-picker>
          <vs-input :placeholder="$tc('number')" v-model="callbackSearchParams.number" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="callbackSearchParams.to" :model="callbackSearchParams.to" :placeholder="$t('date_filter_to')" class="mb-3"></date-picker>
<!--          <v-select :options="resultOptions" :reduce="label => label.value" :placeholder="$t('treatment_result')" v-model="callbackSearchParams.treatment_result" class="mb-3" />-->
          <select v-model="callbackSearchParams.treatment_result" class="vs-inputx vs-input--input normal mb-3" style="width:100%;" >
            <option value="">{{ $t('treatment_result') }}</option>
            <option v-for="(option, key) in resultOptions" :key="'treatment_result_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-input :placeholder="$tc('brand_name')" v-model="callbackSearchParams.did" class="w-full mb-3"/>
<!--          <v-select :options="counselorsOptions" :reduce="label => label.value" :placeholder="$t('callback.name')" v-model="callbackSearchParams.assigned_agent_name" class="mb-3" />-->
          <select v-model="callbackSearchParams.assigned_agent_name" class="vs-inputx vs-input--input normal mb-3" style="width:100%;" >
            <option value="">{{ $t('callback.name') }}</option>
            <option v-for="(option, key) in counselorsOptions" :key="'assigned_agent_name_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <vs-input :placeholder="$tc('caller_id')" v-model="callbackSearchParams.caller_id" class="w-full mb-3"/>
          <vs-input :placeholder="$tc('consulting_title')" v-model="callbackSearchParams.consulting_title" class="w-full"/>
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadCallbackData(1, null, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="consultationCallbackDataContainer" :title="$t('callbacks')" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-consultations-tab-nav></shared-consultations-tab-nav>
      </template>

      <shared-user-consultations-callback-list
        :callbacks="callbacks"
        :resultOptions="resultOptions"
        @openOutboundPopup="openOutboundPopup"
        @updateTreatmentResult="updateTreatmentResult"
      ></shared-user-consultations-callback-list>

      <template slot="footer">
        <paginate
          :total="callbackPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadCallbackData"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>

    <modal title="" id="outboundConsultation" :active.sync="modals.outbound" size="xl">
      <shared-outbound-consultation @outboundConsultationSuccess="outboundConsultationSuccess"></shared-outbound-consultation>
      <vs-divider></vs-divider>
      <div class="flex justify-end">
        <vs-button id="editUserPermissionButton" color="primary" type="filled" @click="initSaveOutboundConsultationFormData">{{ $t('enrollment') }}</vs-button>
      </div>
    </modal>

  </div>
</template>

<script>
import SharedConsultationsTabNav from '@/views/Shared/Consultations/TabNav'
import Callback from '@/models/Callback'
import SharedUserConsultationsCallbackList from '@/views/Shared/Consultations/Callbacks/List'
import Paginate from '@/mixins/paginate'
import SharedOutboundConsultation from '@/views/Shared/Consultations/Outbound'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'
import announcementSocket from '@/libs/sockets/announcements'
import DatePicker from '@/components/form-inputs/DatePicker'

export default {
  name: 'User.Consultations.Callback',
  mixins: [Paginate],
  components: {
    SharedConsultationsTabNav,
    SharedUserConsultationsCallbackList,
    Modal,
    SharedOutboundConsultation,
    DatePicker
  },
  data () {
    return {
      mode: 'socket', // [sw, socket]
      companyId: this.$store.getters.userInfo.company.id,
      resultOptions: [],
      counselorsOptions: [],
      callbacks: {},
      callbackPages: 1,
      itemPerPage: null,
      callbackSearchParams: {
        from: typeof this.$route.query.from !== 'undefined' ? this.$route.query.from : '',
        to: typeof this.$route.query.to !== 'undefined' ? this.$route.query.to : '',
        did: typeof this.$route.query.did !== 'undefined' ? this.$route.query.did : '',
        name: typeof this.$route.query.name !== 'undefined' ? this.$route.query.name : '',
        caller_id: typeof this.$route.query.caller_id !== 'undefined' ? this.$route.query.caller_id : '',
        number: typeof this.$route.query.number !== 'undefined' ? this.$route.query.number : '',
        treatment_result: typeof this.$route.query.treatment_result !== 'undefined' ? this.$route.query.treatment_result : '',
        assigned_agent_name: typeof this.$route.query.assigned_agent_name !== 'undefined' ? this.$route.query.assigned_agent_name : '',
        consulting_title: typeof this.$route.query.consulting_title !== 'undefined' ? this.$route.query.consulting_title : ''
      },
      callbackExportParams: {},
      modals: {
        outbound: false
      },
      isManager: false,
      userId: null
    }
  },
  computed: {
    server () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {}
    }
  },
  mounted () {
    this.loadCallbackData(this.initialPage, null)

    if (this.mode === 'socket') {
      document.addEventListener('readystatechange', () => {
        if (document.readyState === 'complete' && typeof (Worker) !== 'undefined') {
          announcementSocket.getSocket().on('new_callback', () => {
            this.loadCallbackData(1, null, true)
          })
        }
      })
    }
    announcementSocket.setNode(this.server)

    this.$windowOpenerHelper.listenToPopUpMessage('reload_consultation_callback_member_table', this.loadCallbackData)
  },
  methods: {
    async loadCallbackData (page = 1, itemPerPage = null, backToPageOne = false) {
      this.$vs.loading({container: '#consultationCallbackDataContainer'})

      if (itemPerPage !== null) {
        this.itemPerPage = itemPerPage
      } else if (this.itemPerPage !== null) {
        itemPerPage = this.itemPerPage
      }

      this.$router.replace({ query: { ...this.callbackSearchParams, page, itemPerPage } })
      const response = await Callback.all({ ...this.callbackSearchParams, page, itemPerPage })
      this.callbacks = response.data.data.callbacks
      this.resultOptions = response.data.meta.options.results
      this.counselorsOptions = response.data.meta.options.agents
      this.callbackPages = response.data.meta.pagination.last_page
      this.isManager = response.data.meta.isManager
      this.userId = response.data.meta.userId
      this.itemPerPage = response.data.meta.pagination.per_page
      this.callbackExportParams = this.callbackSearchParams
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }

      this.$vs.loading.close('#consultationCallbackDataContainer > .con-vs-loading')
    },
    async exportData (e) {
      e.preventDefault()
      try {
        const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
        await Callback.export({...this.callbackExportParams, isManager: this.isManager, userId: this.userId, companyId: this.companyId, companyCanUseCallbackAmount: this.$store.getters.hasCompanyPermission('company_can_use_callback_amount'), companyCanUseCallbackShareFunction: this.$store.getters.hasCompanyPermission('company_can_use_callback_share_function'), language})
      } catch (e) {
        this.$alertHelper.error()
      }
    },
    outboundConsultationModal (data) {
      EventBus.$emit('initResetOutboundConsultationFormData')
      EventBus.$emit('initLoadOutboundConsultation', { member_id: data.id, callback_id: data.callback_id })
      this.modals.outbound = true
    },
    openOutboundPopup (memberId, callbackId, phoneNumber, members) {
      if (members > 1) {
        Utils.openPopUp(this.$store.getters.ctiPopUp, 'outbound-select-member', { callback_id: callbackId, phone_number: phoneNumber })
      } else {
        Utils.openPopUp(this.$store.getters.ctiPopUp, 'outbound', { id: memberId, callback_id: callbackId }, this.outboundConsultationModal)
      }
    },
    outboundConsultationSuccess (response) {
      this.$swalHelper.success({
        title: this.$t('action_success'),
        text: this.$t(response.data),
        confirmButton: this.$t('confirm')
      })
      this.modals.outbound = false
      this.loadCallbackData(this.initialPage, this.itemPerPage)
    },
    initSaveOutboundConsultationFormData () {
      EventBus.$emit('initSaveOutboundConsultationFormData')
    },
    async updateTreatmentResult (indextr, data) {

      await Callback.updateTreatmentResult(data)
      this.callbacks[indextr].type = data.type

      if (data['result_type_id'] === 1) {
        this.callbacks[indextr].type = 'A'
      } else if (data['result_type_id'] === 2) {
        this.callbacks[indextr].type = 'B'
      } else if (data['result_type_id'] === 3) {
        this.callbacks[indextr].type = 'C'
      } else if (data['result_type_id'] === 4) {
        this.callbacks[indextr].type = 'D'
      } else {
        this.callbacks[indextr].type = ''
      }

      announcementSocket.getSocket().emit('init_message_management_count')

    }
  }
}
</script>

<style scoped>

</style>
